var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_account_circle_24px",
    d: "M12.5,2A10.5,10.5,0,1,0,23,12.5,10.5,10.5,0,0,0,12.5,2Zm0,3.15A3.15,3.15,0,1,1,9.35,8.3,3.146,3.146,0,0,1,12.5,5.15Zm0,14.91a7.561,7.561,0,0,1-6.3-3.381c.032-2.089,4.2-3.234,6.3-3.234s6.268,1.144,6.3,3.234A7.561,7.561,0,0,1,12.5,20.06Z",
    transform: "translate(-2 -2)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f5438b22f5259f5939d34d3637e28019.svg";
export { ForwardRef as ReactComponent };